// Staffing per 15-minute slot for a team (and jobs) on a day: Scheduled (on a
// Paycor shift), Out (the share of the slot on an absence notification),
// Break / Lunch (the share on a break or lunch -- planned or actual -- of the
// part not out) and Available (the rest), for the Break & Lunch Schedule
// page's summary rows. One person never adds up to more than 1.
// Campaign Stats Today > Staffing counts the same way on the server, by shift
// department (routes/scheduled_staffing.py, /api/scheduled-staffing/slots).

// 'HH:MM' -> minutes after midnight.
export const slotMins = (slot) => parseInt(slot.slice(0, 2), 10) * 60 + parseInt(slot.slice(3), 10);

// An agent state (actual data, Active 4 SLA already left out by the server)
// as QA Coaching, Lunch, Break, or Non-ACD (the rest).
export function classifyState(state) {
  if (state === 'QA Coaching') return 'QA Coaching';
  const s = (state || '').toLowerCase();
  if (s.includes('lunch') || s.includes('meal')) return 'Lunch';
  if (s.includes('break')) return 'Break';
  return 'Non-ACD';
}

const r2 = (v) => Math.round(v * 100) / 100;

/**
 * [{ sched, out, brk, offq, avail }] per slot; out / brk / offq / avail can be fractions.
 *   agents       [{ ID }]
 *   slots        ['HH:MM', ...]
 *   shiftMap     { userId: [{ start: 'HH:MM', end: 'HH:MM' }] }
 *   absentFrac   (userId, slot) => 0..1, the share of the slot on an absence
 *   breakFrac    (userId, slot) => 0..1, the share on a break or lunch
 *   offqFrac     (userId, slot) => 0..1, the share off the queue otherwise
 *                (QA Coaching / Non-ACD); optional
 */
export function staffingPerSlot({ agents, slots, shiftMap, absentFrac, breakFrac, offqFrac }) {
  return slots.map((slot) => {
    let sched = 0; let out = 0; let brk = 0; let offq = 0;
    for (const a of agents) {
      const inShift = (shiftMap[a.ID] || []).some((sh) => slot >= sh.start && slot < sh.end);
      if (!inShift) continue;
      sched += 1;
      const o = Math.min(absentFrac(a.ID, slot) || 0, 1);
      out += o;
      // A break counts only against the part of the slot not out; time off
      // the queue only against what is left after both.
      if (o < 1) {
        const b = Math.min(breakFrac(a.ID, slot) || 0, 1 - o);
        brk += b;
        if (offqFrac) offq += Math.min(offqFrac(a.ID, slot) || 0, 1 - o - b);
      }
    }
    return { sched, out: r2(out), brk: r2(brk), offq: r2(offq), avail: r2(sched - out - brk - offq) };
  });
}

// The share of a 15-minute slot an agent's absences (Spans in minutes, from
// /api/absences/for-day) cover.
export function absenceShare(list, slot) {
  if (!list) return 0;
  const a0 = slotMins(slot); const a1 = a0 + 15;
  let mins = 0;
  for (const a of list) for (const [f, t] of a.Spans) mins += Math.max(0, Math.min(t, a1) - Math.max(f, a0));
  return Math.min(mins, 15) / 15;
}
